import { DeviceDetect, DeviceType } from "sb-resp-lib";
import { IDeviceAvailability } from "../../../data";

export class DeviceDetectHelper {
    public deviceDetect: DeviceDetect;

    constructor(deviceTypeDetect: DeviceDetect) {
        this.deviceDetect = deviceTypeDetect;
    }

    public itemDeviceFilter(items: IDeviceAvailability[]): IDeviceAvailability[] {
        return items.filter(item => !!item.AllowDevices[this.getDeviceType()]);
    }

    private getDeviceType(): string {
        if (this.deviceDetect.isDesktop) {
            return DeviceType.desktop;
        } else if (this.deviceDetect.isMobile) {
            return DeviceType.mobile;
        } else if (this.deviceDetect.isTablet) {
            return DeviceType.tablet;
        }

        throw "not implemented device type";
    }
}